module.exports = __webpack_public_path__ + "static/media/img-people@2x.0d9f7efd.png";